import ObjectUtils from '@/modules/Object/ObjectUtils';
import { Commit } from 'vuex';
import { ForexHistoryState } from '@/feature/TrHistory/store/interface';
import { ForexHistoryFilter } from '@/feature/TrHistory/api/forex-history.interface';
import { ForexHistoryMutation } from '@/feature/TrHistory/store/constants';
import NumberFormat from '@/modules/NumberCore/NumberFormat';

export const getHistoryFilter = (
	state: ForexHistoryState
): ForexHistoryFilter => {
	const filter: ForexHistoryFilter = ObjectUtils.excludeEmpty({
		id: state.id,
		fromRequestAmount: NumberFormat.fixNum(state.fromRequestAmount || 0),
		toRequestAmount: NumberFormat.fixNum(state.toRequestAmount || 0),
		status: state.status,
		type: state.type,
		fromOperDay: state.fromOperDay,
		toOperDay: state.toOperDay,
		currency: state.currency,
		pageNumber: state.pageNumber,
		elementsOnPage: state.pageSize
	}) as ForexHistoryFilter;

	if ((filter.fromOperDay && !filter.toOperDay)
		|| (!filter.fromOperDay && filter.toOperDay)) {
		delete filter.fromOperDay;
		delete filter.toOperDay;
	}

	return filter;
};

export const getHistoryNextPageFilters = (
	state: ForexHistoryState,
	commit: Commit
): ForexHistoryFilter => {
	if (!state.isEndPage)
		commit(ForexHistoryMutation.setNextPage);

	return getHistoryFilter(state);
};

export const nextPageIsAvailable = (
	{ state, getters, commit }: any,
	loadingKey: any,
): boolean => !state.isEndPage && !getters[loadingKey];
